<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_user_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 style="color: #724c80" class="font-weight-bold">
            {{ $t("PLACEHOLDERS.summaryData") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.first_name')"
            v-model.trim="data.first_name"
            required
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.last_name')"
            v-model.trim="data.last_name"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Email Input -->

          <!-- Start:: date Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.birthDate')"
            v-model.trim="data.birthday"
            required
          />
          <!-- End:: date Input -->

          <base-select-input
            col="6"
            :optionsList="areas"
            :placeholder="$t('PLACEHOLDERS.areaOr')"
            v-model="data.area_id"
            required
          />
          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            :autocomplete="'off'"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.password_confirmation"
            :autocomplete="'off'"
            required
          />
          <!-- End:: Confirm Password Input -->
          <h5 style="color: #724c80" class="font-weight-bold mt-5">
            {{ $t("PLACEHOLDERS.jobDetails") }}
          </h5>

          <base-select-input
            col="4"
            :optionsList="qualifications"
            :placeholder="$t('PLACEHOLDERS.qualifications')"
            v-model="data.educational_qualification_id"
            required
          />
          <base-select-input
            col="4"
            :optionsList="works"
            :placeholder="$t('PLACEHOLDERS.works')"
            v-model="data.scope_work_id"
            required
          />
          <base-select-input
            col="4"
            :optionsList="specializations"
            :placeholder="$t('PLACEHOLDERS.specializations')"
            v-model="data.specialized_id"
            required
          />
          <h6 style="color: #724c80">
            {{ $t("PLACEHOLDERS.cv") }}
          </h6>
          <div class="col-6">
            <div
              class="upload-icon-wrapper"
              @click="$refs.cvInput.click()"
              style="cursor: pointer"
            >
              <i
                class="fas fa-upload"
                style="font-size: 25px; color: #724c80"
              ></i>
              <span class="mx-2 text-gray-300">{{
                data.cv ? data.cv.name : $t("PLACEHOLDERS.uploadCv")
              }}</span>
              <i
                v-if="data.cv"
                class="fas fa-times text-danger mx-2"
                style="cursor: pointer"
                @click.stop="data.cv = null"
              ></i>
              <input
                ref="cvInput"
                type="file"
                accept=".pdf, .png, .jpeg, .jpg"
                @change="
                  (e) => {
                    const file = e.target.files[0];
                    const allowedTypes = ['.pdf', '.png', '.jpeg', '.jpg'];
                    const fileExtension =
                      '.' + file.name.split('.').pop().toLowerCase();

                    if (!allowedTypes.includes(fileExtension)) {
                      this.$message.error(this.$t('MESSAGES.invalidFileType'));
                      e.target.value = '';
                      return;
                    }

                    this.data.cv = file;
                  }
                "
                style="display: none"
              />
            </div>
          </div>
          <!-- Start:: Deactivate Switch Input -->
          <base-select-input
            col="12"
            :optionsList="expStatus"
            :placeholder="$t('PLACEHOLDERS.expStatus')"
            v-model="data.have_experience"
            required
          />
          <!-- End:: Deactivate Switch Input -->
          <base-input
            type="number"
            col="6"
            v-model.trim="data.experience_years"
            :placeholder="$t('PLACEHOLDERS.expCount')"
            v-if="data.have_experience?.value == 'yes'"
          />

          <div class="row col-12" v-if="data.have_experience?.value == 'yes'">
            <div
              class="col-12"
              v-for="(item, index) in data.experiences"
              :key="'l' + index"
            >
              <div class="item d-flex flex-wrap align-items-center">
                <base-input
                  col="6"
                  class="w-100"
                  type="text"
                  required
                  :placeholder="$t('PLACEHOLDERS.company_name')"
                  v-model.trim="item.company_name"
                />
                <!-- <base-input
                  col="6"
                  type="number"
                  :placeholder="$t('PLACEHOLDERS.expCount')"
                  v-model.trim="item.years"
                  required
                /> -->
                <base-picker-input
                  col="6"
                  type="date"
                  :placeholder="$t('PLACEHOLDERS.from')"
                  v-model.trim="item.from_date"
                  required
                />
                <base-picker-input
                  col="6"
                  type="date"
                  :placeholder="$t('PLACEHOLDERS.to')"
                  v-model.trim="item.to_date"
                  required
                />
                <div class="all_actions" v-if="data.experiences?.length > 1">
                  <span
                    @click="removeRow(index)"
                    style="color: #dc3545; font-size: 25px; cursor: pointer"
                  >
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
                <div class="col-l2 mx-2">
                  <div
                    @click="addRow"
                    style="color: #724c80; font-size: 25px; cursor: pointer"
                  >
                    <i class="fas fa-plus-circle"></i>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateAdmin",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        have_experience: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        birthday: null,
        experience_years: null,
        area_id: null,
        password: null,
        password_confirmation: null,
        educational_qualification_id: null,
        scope_work_id: true,
        specialized_id: true,
        cv: null,
        experiences: [
          {
            company_name: null,
            years: null,
            from_date: null,
            to_date: null,
          },
        ],
      },
      qualifications: [],
      areas: [],
      works: [],
      specializations: [],
      allAreas: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
    expStatus() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: "yes",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: "no",
        },
      ];
    },
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions
    addRow() {
      this.data?.experiences.push({
        company_name: null,
        years: null,
        from_date: null,
        to_date: null,
      });
    },

    removeRow(index) {
      this.data?.experiences.splice(index, 1);
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectCV(selectedImage) {
      this.data.cv = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs
    async getAreas() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `areas?page=0&limit=0&is_active=1`,
        });
        this.areas = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getWorks() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `scope-works?page=0&limit=0&is_active=1`,
        });
        this.works = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getSpecializations() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `specializations?page=0&limit=0&is_active=1`,
        });
        this.specializations = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getQualifications() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `educational-qualifications?page=0&limit=0&is_active=1`,
        });
        this.qualifications = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // // Start:: Append Request Data
      if (this.data.logo.file) {
        REQUEST_DATA.append("logo", this.data.logo.file);
      }
      if (this.data.cv) {
        REQUEST_DATA.append("cv", this.data.cv);
      }
      if (this.data.first_name) {
        REQUEST_DATA.append("first_name", this.data.first_name);
      }
      if (this.data.last_name) {
        REQUEST_DATA.append("last_name", this.data.last_name);
      }
      if (this.data.phone) {
        REQUEST_DATA.append("mobile", this.data.phone);
      }
      if (this.data.email) {
        REQUEST_DATA.append("email", this.data.email);
      }
      if (this.data.birthday) {
        REQUEST_DATA.append("birthday", this.data.birthday);
      }
      if (this.data.area_id?.id) {
        REQUEST_DATA.append("area_id", this.data.area_id.id);
      }
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }
      if (this.data.password_confirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.password_confirmation
        );
      }
      if (this.data.educational_qualification_id?.id) {
        REQUEST_DATA.append(
          "educational_qualification_id",
          this.data.educational_qualification_id.id
        );
      }
      if (this.data.scope_work_id?.id) {
        REQUEST_DATA.append("scope_work_id", this.data.scope_work_id.id);
      }
      if (this.data.specialized_id?.id) {
        REQUEST_DATA.append("specialized_id", this.data.specialized_id.id);
      }
      if (this.data.have_experience?.value) {
        REQUEST_DATA.append("have_experience", this.data.have_experience.value);
      }
      if (
        this.data.have_experience?.value == "yes" &&
        this.data.experience_years
      ) {
        REQUEST_DATA.append(`experience_years`, this.data.experience_years);
      }
      if (
        this.data.have_experience?.value == "yes" &&
        this.data.experiences?.length
      ) {
        this.data.experiences.forEach((exp, index) => {
          // if (exp.years) {
          //   REQUEST_DATA.append(`experiences[${index}][years]`, exp.years);
          // }
          if (exp.company_name) {
            REQUEST_DATA.append(
              `experiences[${index}][company_name]`,
              exp.company_name
            );
          }
          if (exp.from_date) {
            REQUEST_DATA.append(
              `experiences[${index}][from_date]`,
              exp.from_date
            );
          }
          if (exp.to_date) {
            REQUEST_DATA.append(`experiences[${index}][to_date]`, exp.to_date);
          }
        });
      }

      try {
        await this.$axios({
          method: "POST",
          url: `clients`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/Clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getSpecializations();
    this.getWorks();
    this.getQualifications();
    this.getAreas();
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
